import { IGeoSuggestItem } from '../../../common/components/geo_suggest';
import { IAppState } from '../../../common/state';

export const selectRegionalDistrictsForSearch = (state: IAppState): IGeoSuggestItem<number>[] => {
  const { districts } = state.filters.regionalDistrictsModal;

  return districts.map(({ id, name }) => ({ title: name, value: id }));
};
